import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import SignInModal from '@/components/app/SignInModal';
import ButtonCTA from '@/components/component-library/Button/CTA';
import { classes } from '@/helpers/styling';
import { SIGN_IN_KEY } from '@/config/routeKeys';
import { addCurrentPathToHref } from '@/helpers/routing';

const SignInLink = ({
  className,
  onClick,
  useModal
}) => {
  const { asPath } = useRouter();

  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  const handleClick = useCallback(() => {
    handleOpenModal();

    if (onClick) {
      onClick();
    }
  }, [onClick, handleOpenModal]);

  return (
    <>
      <ButtonCTA
        className={classes('login-button', { [className]: !!className })}
        href={useModal ? undefined : addCurrentPathToHref({
          href: SIGN_IN_KEY,
          asPath
        })}
        id='login-button'
        onClick={handleClick}
      >
        Sign In
      </ButtonCTA>
      {useModal && <SignInModal onClickSkip={handleCloseModal} open={modalOpen} />}
    </>
  );
};

SignInLink.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  useModal: PropTypes.bool
};

SignInLink.defaultProps = {
  className: '',
  onClick: null,
  useModal: true
};

export default SignInLink;
